const normalizeBase = (base?: string): string => {
  if (!base) return '/api';
  let b = base.trim().replace(/\/+$/, '');
  if (!/\/api(\/|$)/i.test(b)) b = `${b}/api`;
  return b;
};

const API_BASE = normalizeBase(process.env.REACT_APP_API_BASE_URL || '');

export interface AuthUser {
  username: string;
  roles?: string[];
}

export class AuthService {
  async me(): Promise<AuthUser | null> {
    try {
      const res = await fetch(`${API_BASE}/auth/me`, { credentials: 'include' });
      if (res.status === 401 || res.status === 403) return null;
      if (!res.ok) return null;
      try {
        return await res.json() as AuthUser;
      } catch {
        return { username: '' };
      }
    } catch {
      return null;
    }
  }

  async login(username: string, password: string): Promise<AuthUser> {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
      credentials: 'include',
    });
    if (!res.ok) {
      throw new Error('Ungültige Anmeldedaten');
    }
    try {
      return await res.json() as AuthUser;
    } catch {
      return { username };
    }
  }

  async logout(): Promise<void> {
    try {
      await fetch(`${API_BASE}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch {
      // Session trotzdem lokal beenden
    }
  }

  async register(username: string, password: string, role: 'USER' | 'ADMIN'): Promise<{ username: string; role: string }> {
    const res = await fetch(`${API_BASE}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, role }),
      credentials: 'include',
    });
    if (!res.ok) {
      let msg = 'Registrierung fehlgeschlagen';
      try {
        const body = await res.json();
        if (body?.error) msg = body.error;
      } catch {}
      throw new Error(msg);
    }
    return res.json();
  }
}
